import { styled } from '@mui/material/styles';
import { DatePicker, DatePickerValue, SingleLineText } from '@bloomays-lib/ui.shared';
import { startOfMonth } from 'date-fns/startOfMonth';

/** Preview temporaire System sur staging — à retirer avec le dashboard C-level. */
const MONTH_PREVIEW_LABEL = 'Pour le mois de';

export type MonthlyPrimeMonthSelectProps = {
  referenceDate: Date;
  onReferenceDateChange: (referenceDate: Date) => void;
};

const MonthlyPrimeMonthSelect = ({ referenceDate, onReferenceDateChange }: MonthlyPrimeMonthSelectProps) => {
  return (
    <SelectContainer>
      <PreviewLabel text={MONTH_PREVIEW_LABEL} variant="body1Regular" />
      <DatePickerWrapper>
        <DatePicker
          views={['year', 'month']}
          openTo="month"
          value={referenceDate}
          handleChange={(date: DatePickerValue) => {
            if (date) {
              onReferenceDateChange(startOfMonth(date));
            }
          }}
        />
      </DatePickerWrapper>
    </SelectContainer>
  );
};

export default MonthlyPrimeMonthSelect;

const SelectContainer = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(2),
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

const PreviewLabel = styled(SingleLineText)(({ theme }) => ({
  color: theme.palette.neutral.black,
  whiteSpace: 'nowrap',
}));

const DatePickerWrapper = styled('div')(() => ({
  minWidth: '200px',
}));
